export function getTouchEventClientX(event: TouchEvent): number | null {
  const touch = event.touches[0]

  return touch ? touch.clientX : null
}
